function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-5{fill:#1a1a1a;}.cls-6{fill:#ffef11;fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M2.35,84.42,45.28,10.2l.17-.27h0A23,23,0,0,1,52.5,2.69,17,17,0,0,1,61.57,0a16.7,16.7,0,0,1,9.11,2.69,22.79,22.79,0,0,1,7,7.26q.19.32.36.63l42.23,73.34.24.44h0a22.48,22.48,0,0,1,2.37,10.19,17.63,17.63,0,0,1-2.17,8.35,15.94,15.94,0,0,1-6.93,6.6c-.19.1-.39.18-.58.26a21.19,21.19,0,0,1-9.11,1.75v0H17.61c-.22,0-.44,0-.65,0a18.07,18.07,0,0,1-6.2-1.15A16.42,16.42,0,0,1,3,104.24a17.53,17.53,0,0,1-3-9.57,23,23,0,0,1,1.57-8.74,7.66,7.66,0,0,1,.77-1.51Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M9,88.75,52.12,14.16c5.24-8.25,13.54-8.46,18.87,0l42.43,73.69c3.39,6.81,1.71,16-9.33,15.77H17.61C10.35,103.8,5.67,97.43,9,88.75Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M57.57,82.69A5.48,5.48,0,0,1,61,81.11a5.66,5.66,0,0,1,4.42,1.66,5.53,5.53,0,0,1,1.62,3.54A5.6,5.6,0,0,1,67,87.72a6,6,0,0,1-.42,1.34,5.53,5.53,0,0,1-2.92,2.84,5.79,5.79,0,0,1-4.57-.1,5.51,5.51,0,0,1-2.81-2.94,5.31,5.31,0,0,1-.36-1.27,5.9,5.9,0,0,1-.06-1.32h0a6.45,6.45,0,0,1,.57-2,4.6,4.6,0,0,1,1.14-1.56Zm8.15-10.24c-.19,4.79-8.31,4.8-8.49,0-.82-8.21-2.92-27.7-2.86-35.42.07-2.38,2-3.78,4.56-4.32a11.19,11.19,0,0,1,2.49-.24,11.77,11.77,0,0,1,2.5.25c2.61.55,4.65,2,4.65,4.44v.24L65.72,72.45Z"
});

function SvgCautionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 111.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCautionIcon);
export default __webpack_public_path__ + "static/media/caution-icon.a4caae07.svg";
export { ForwardRef as ReactComponent };